import script from "./FilterSubstrate.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilterSubstrate.vue?vue&type=script&setup=true&lang=ts"

import "./FilterSubstrate.vue?vue&type=style&index=0&id=d35d4510&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d35d4510"]])

export default __exports__